export const SELECT_AREA = "SELECT_AREA"
